module.exports = __webpack_public_path__ + "img/bg-shape1.86a81189.jpg";